<template>
  <!-- Main Footer-->
  <footer class="footer mt-auto py-3 bg-white text-center">
    <div class="container">
      <span class="text-muted">
        {{ $t('footer.copyright') }} © <span id="year">{{ year }}</span>
        <a class="ms-2" href="javascript:void(0)">Copec Flux</a>.
        {{ $t('footer.all_rights_reserved') }}
      </span>
    </div>
  </footer>
  <!--End Footer-->
</template>

<script setup>
import { computed } from 'vue'
import dayjs from 'dayjs'

const year = computed(() => dayjs().year())
</script>
